import React from 'react'

const FeedbackEdit = () => {
  return (
    <div>FeedbackEdit</div>
  )
}

export default FeedbackEdit